export const DEFAULT_WALL_SIZES = {
  EXTERIOR_WALLS: {
    thickness: 24,
    height: 288,
  },
  INTERIOR_WALLS: {
    thickness: 17,
    height: 96,
  },
  OBSTRUCTIONS: {
    thickness: 17,
    height: 48,
  },
} as const
